(function() {
  function truncatePills() {
    var isMobile = window.innerWidth < 768;
    document.querySelectorAll('.opt-label--btn .js-value').forEach(function(el) {
      if (!el.dataset.full) el.dataset.full = el.textContent.trim();
      if (isMobile) {
        el.textContent = el.dataset.full.split(/\s*[–—-]\s*/)[0].trim();
      } else {
        el.textContent = el.dataset.full;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', truncatePills);
  } else {
    truncatePills();
  }

  window.addEventListener('resize', truncatePills);

  var observer = new MutationObserver(function(mutations) {
    var found = false;
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(n) {
        if (n.nodeType === 1 && (n.matches('.opt-label--btn') || n.querySelector('.opt-label--btn'))) found = true;
      });
    });
    if (found) truncatePills();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
